export default __webpack_public_path__ + "static/media/portfolio-102.9f031675.jpg";